import { LOADING_STATUS } from 'client/js/main/support/constants';
import type { CostFileTemplateState } from 'client/js/redux/domains/CostFileTemplate/CostFileTemplate.types';
import { ReduxAsyncActionsService } from 'client/js/redux/services/ReduxAsyncActions.service';
import type { WrappedReducer } from 'client/js/redux/types/ReduxAsyncActions.types';
import { INIT_STATE } from './CostFileTemplate.constants';

import {
  SETUP_COST_FILE_TEMPLATE_ACTION,
  type SetupCostFileTemplateResponseAction,
} from './actions/setupCostFileTemplate.action';

import {
  PATCH_COST_FILE_TEMPLATE_ACTION,
  type PatchCostFileTemplateResponseAction,
} from './actions/patchCostFileTemplate.action';

import {
  GET_COST_FILE_TEMPLATE_BY_ID_ACTION,
  type GetCostFileTemplateByIdResponseAction,
} from './actions/getCostFileTemplateById.action';

import {
  type GetCostFileTemplateAdPartnersAction,
  ROI_COST_FILE_TEMPLATE_AD_PARTNERS,
} from './actions/getCostFileTemplateAdPartners.action';

type Action =
  | SetupCostFileTemplateResponseAction
  | GetCostFileTemplateByIdResponseAction
  | PatchCostFileTemplateResponseAction
  | GetCostFileTemplateAdPartnersAction;

function Handler(state: WrappedReducer<CostFileTemplateState>, action: Action): WrappedReducer<CostFileTemplateState> {
  switch (action.type) {
    case SETUP_COST_FILE_TEMPLATE_ACTION.response: {
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    }
    case PATCH_COST_FILE_TEMPLATE_ACTION.response: {
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    }
    case GET_COST_FILE_TEMPLATE_BY_ID_ACTION.response: {
      return {
        ...state,
        data: [action.data],
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    }
    case ROI_COST_FILE_TEMPLATE_AD_PARTNERS: {
      return {
        ...state,
        ...action.data,
      };
    }
    default:
      return state;
  }
}

const CostFileTemplateReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, Handler, {
  request: [SETUP_COST_FILE_TEMPLATE_ACTION, GET_COST_FILE_TEMPLATE_BY_ID_ACTION, PATCH_COST_FILE_TEMPLATE_ACTION],
  error: [SETUP_COST_FILE_TEMPLATE_ACTION, GET_COST_FILE_TEMPLATE_BY_ID_ACTION, PATCH_COST_FILE_TEMPLATE_ACTION],
});

export default CostFileTemplateReducer;
